export default {
  title: 'Purchase',

  labels: {
    defaultStoreroom: 'Default warehouse for purchase',
    hasPrePurchaseInvoiceAge: 'Pre-purchase invoice deleted after special time',
    prePurchaseInvoiceAge: 'Pre-purchase invoice deleted after ... days.',
    hasPreReturnPurchaseInvoiceAge: 'Pre-purchase return invoice deleted after special time',
    preReturnSaleInvoiceAge: 'Pre-purchase return invoice deleted after ... days.'
  },

  notifications: {
    edit: {
      success: 'Edit purchase setting successfully done',
      error: 'Edit purchase setting has error'
    },

    parseError: {
      prePurchaseInvoiceAge: 'Number of days for delete pre-purchase invoice is incorrect',
      preReturnSaleInvoiceAge: 'Number of days for delete pre-purchase return invoice is incorrect'
    }
  }
}
